export default "__VITE_ASSET__CVkxwL3e__"